// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"2d6c1b40","453":"9b227865"}[chunkId] + ".chunk.js";
};